$(function(){
	youtubeModal();
	homeBannerSlick();
	homeTileSlick();
	featureTileSlick();
	genericTables();
});

$(document).ready(function(){

	$(document).on("click", "[aria-pressed][aria-controls]", function(e){
		e.preventDefault();
		var $el = $(e.target);
		var $ex = $("[data-exclusive=true][aria-pressed=true]").not($el);
		if ("true" == $(this).attr("data-exclusive") && $ex.length){
			toggleAria($ex);
		}
		toggleAria($el);
	});

	$(document).on("click", ".w-popup-menu-toggle", function(){
		$("body").toggleClass("w-disable-scrolling");
	});

	$(document).on("click", ".nav-link-expand", function(){
		$(this).toggleClass("nav-link-expanded");
	});

	$('#categoryFilter_desktop .mobile-btn').click(function(e) {
		$('#categoryFilter_desktop .filterSidebar').toggle();
	});

	var cw = $('.media-item-sm .tile-img').width();
	var ch = cw * 0.863;
	$('.media-item-sm .tile-img').css({'height':ch+'px'});

	$(window).resize(function() {
		var cw = $('.media-item-sm .tile-img').width();
		var ch = cw * 0.863;
		$('.media-item-sm .tile-img').css({'height':ch+'px'});
	});

	if ($('.homeMediaSec .all-media-items li:gt(4)')){
		$('.homeMediaSec .all-media-items li:gt(4)').remove();
		$('.homeMediaSec .media-block').append('<p class="media-view-more"><a class="view-more-btn" href="/media">View More</a></p>');
	}

	if ($('.mediaSec .all-media-items li:gt(4)')){
		$('.mediaSec .all-media-items li:gt(4)').hide();
		$('.mediaSec .media-block').append('<p class="media-view-more"><a class="view-more-btn" href="">View More</a></p>');
		$('.mediaSec .media-block .view-more-btn').click(function(e){
			e.preventDefault();
			$('.mediaSec .all-media-items li').show().css({'display':'inline-block'});
			$(this).hide();
		});
	}

	$('.slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false
	});
	$('.slider-for').on('afterChange', function(event, slick, currentSlide, nextSlide){
		var $navItem = $('.apparel-slider-nav .item:nth-child(' + (currentSlide+1) + ')');
		if ($navItem.length){
			$navItem.siblings().removeClass('active');
			$navItem.addClass('active');
		}
	});
	$('.apparel-slider-nav .item, .gallery-slider-nav .item').on('click', function(){
		var $me = $(this);
		// $me.siblings().removeClass('active');
		// $me.addClass('active');
		$('.slider-for').slick('slickGoTo', $me.index());
	});
	$('.apparel-slider-nav .item:first, .gallery-slider-nav .item:first').addClass('active');

});


function youtubeModal(){
  var $videoSrc;
  $('.video-btn').click(function() {
    $videoSrc = "https://www.youtube.com/embed/" + $(this).data( "src" );
  });

  // when the modal is opened autoplay it
  $('#video_pop').on('shown.bs.modal', function (e) {

  // set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
  $("#video").attr('src',$videoSrc + "?autoplay=1" );
  });
    // stop playing the youtube video when I close the modal
  $('#video_pop').on('hide.bs.modal', function (e) {
    $("#video").attr('src',$videoSrc);
  });
}


function homeBannerSlick(){
	$('.home-banner').slick({
		arrows: false,
		speed: 500,
		dots: true,
		slidesToShow: 1,
		infinite: true,
		slidesToScroll: 1,
		fade: true,
		cssEase: 'linear'
	});
}


function homeTileSlick(){
	$(window).on('load resize', function() {
		if ($(window).width() > 768) {
			if ($('.range-block').hasClass('slick-initialized')) {
				$('.range-block').slick('unslick');
			}
			return;
		}
		if (!$('.range-block').hasClass('slick-initialized')) {
			return $('.range-block').slick({
				mobileFirst:true,
				prevArrow: false,
				nextArrow: false,
				infinite: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							centerMode: true,
							centerPadding: '50px',
							slidesToShow: 1,
						}
					},
					{
						breakpoint:1,
						settings: {
							centerMode: true,
							centerPadding: '45px',
							slidesToShow: 1
						}
					}
				]
			});
		}
	});
}

function featureTileSlick(){
	$(window).on('load resize', function() {
		if ($(window).width() > 768) {
			if ($('.featureProductSec .productTileBox').hasClass('slick-initialized')) {
				$('.featureProductSec .productTileBox').slick('unslick');
			}
			return;
		}
		if (!$('.featureProductSec .productTileBox').hasClass('slick-initialized')) {
			return  $('.featureProductSec .productTileBox').slick({
				mobileFirst:true,
				prevArrow: false,
				nextArrow: false,
				infinite: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							centerMode: true,
							centerPadding: '50px',
							slidesToShow: 1,
						}
					},
					{
						breakpoint:1,
						settings: {
							centerMode: true,
							centerPadding: '45px',
							slidesToShow: 1
						}
					}
				]
			});
		}
	});
}
function genericTables(){
	var $tables = $('.generic-table');
	$tables.each(function(){
		var $t = $(this);
		var $ths = $t.find('thead th');
		var $trs = $t.find('tbody tr');
		$trs.each(function(){
			var $row = $(this);
			var $cols = $row.children();
			if ($ths.length != $cols.length) return;
			$cols.each(function(i){
				var $me = $(this);
				var heading = $ths.eq(i).text();
				$me.prepend('<span class="generic-table-mobile-heading">' + heading + '</span>');
			});
		});
	});
}

function toggleAria($el){
	toggleAriaPressed($el);
	toggleAriaHiddenOnControlled($el);
}

function toggleAriaPressed($el){
	toggleAttr($el, 'aria-pressed');
}

function toggleAriaHiddenOnControlled($el){
	var controlled = $el.attr("aria-controls");
	if (controlled){
		var id = "#" + controlled.replace(/\s/g, ' #').trim();
		toggleAttr($(id), 'aria-hidden');
	}
}

function toggleAttr($el, attr){
	if ($el && $el.length && attr){
		var val = $el.attr(attr) == "true" ? true : false;
		$el.attr(attr, (!val).toString().toLowerCase());
	}
	else {
		console.log('toggle aria error');
	}
}
